// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1M-Wb","row":"ProcedureTreatmentSummary_row__1cAS0"};